import { render, staticRenderFns } from "./ModifierSelection.vue?vue&type=template&id=ece95d38&"
import script from "./ModifierSelection.vue?vue&type=script&lang=js&"
export * from "./ModifierSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports